import { STATUS_COLORS } from './colors';

const STATUS_DEFS = [
  { value: 'not_started', label: 'Not Started' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'done',        label: 'Done' },
];

const KANBAN_DEFS = [
  { value: 'not_started',  label: 'Not Started' },
  { value: 'in_progress',  label: 'In Progress' },
  { value: 'verification', label: 'Verification' },
  { value: 'done',         label: 'Done' },
];

export const STATUS_OPTIONS        = STATUS_DEFS.map((s) => ({ value: s.value, label: s.label, dot: STATUS_COLORS[s.value] }));
export const KANBAN_STATUS_OPTIONS = KANBAN_DEFS.map((s) => ({ value: s.value, label: s.label, dot: STATUS_COLORS[s.value] }));
export const STATUS_LABELS         = Object.fromEntries(KANBAN_DEFS.map((s) => [s.value, s.label]));
export const COLUMNS               = STATUS_DEFS.map((s) => ({ status: s.value, title: s.label }));
export const KANBAN_COLUMNS        = KANBAN_DEFS.map((s) => ({ status: s.value, title: s.label }));
